export const HINDI = {
    //-- Error Messages
    ERR_BLANK_USER_NAME: 'Enter user name',
    ERR_BLANK_USER_PASSWORD: 'Enter password',
    ERR_BLANK_EMAIL: 'Enter a email address',
    ERR_BLANK_NEW_PASSWORD: 'Enter a new password',
    ERR_BLANK_CONFIRM_PASSWORD: 'Enter a Confirm password',
    ERR_BLANK_PASSWORD_NOT_MATCH: 'Password not matched',
    ERR_CAN_NOT_BLANK:'Cannot be empty',
    ERR_ONLY_LETTERS:'Only letters',
    ERR_EMAIL_NOT_VALID: 'Email is not valid',
    ERR_MAX_LENGTH:"Max length is 3 only",

    //-- General Messages
    GEN_ARE_YOU_SURE: 'Are you sure ?',
    GEN_NO_RECORD: 'Nilesh',
    GEN_ADD_USER: 'Add User',
    GEN_EDIT_USER: 'Edit User',
    GEN_SEARCH: 'Search',
    GEN_FIRST: 'First',
    GEN_LAST: 'Last',
    GEN_USERS: 'Users',
    GEN_DASHBOARD: 'Dashboard',
    GEN_DESCRIPTION: 'Description',
    GEN_REMARK: 'Remark',
    GEN_NUMBER: 'No',
    GEN_TITLE: 'Title',
    GEN_TYPE: 'Type',
    GEN_IMAGE: 'Image',
    GEN_NAME: 'Name',
    GEN_MESSAGE: 'Message',
    GEN_VIEW_DETAILS: 'View Details',
    GEN_PLEASE_SELECT: 'Please select',
    GEN_DOCUMENT_VERIFICATION:'This is list of pending user',
    GEN_EXPIRY_DATE:'Expiry Date',
    GEN_COUPON_TOKEN:'Coupon Number',

    //-- Headings
    LABEL_USER_NAME: 'User Name',
    LABEL_F_NAME: 'First Name',
    LABEL_L_NAME: 'Last Name',
    LABEL_EMAIL: 'Email',
    LABEL_CONTACT_NO: 'Contact No',
    LABEL_PASSWORD: 'Password',
    LABEL_PHONE: 'Phone',
    LABEL_STATUS: 'Status',
    LABEL_ACTION: 'Action',
    LABEL_CLOSE: 'Close',
    LABEL_REMEMBER_ME: 'Remember Me',
    LABEL_FORGET_PASSWORD: 'Forget Password',
    LABEL_FORGET_PASSWORD_MESSAGE: 'Enter your email address below and we’ll send you updated password on your email.',
    LABEL_BACK_TO: 'Back to',
    LABEL_LOGIN: 'Login',
    LABEL_USER_MGT: 'Users Management',
    LABEL_SETTINGS: 'Settings',
    LABEL_GENERAL_SETTINGS: 'General Settings',
    LABEL_ADMIN_DASHBOARD: 'Admin Dashboard',
    LABEL_CHANGE_PASSWORD: 'Change Password',
    LABEL_NEW_PASSWORD: 'New Password',
    LABEL_OLD_PASSWORD: 'Old Password',
    LABEL_CONFIRM_PASSWORD: 'Confirm Password',
    LABEL_PROFILE: 'Profile',
    LABEL_ADDRESS: 'Address',
    LABEL_UPLOAD_IMAGE:'Upload Image',
    LABEL_USER_DOCUMENT:'User Document',
    LABEL_DETAILS:'Identity Details',
    LABEL_LICENCE_NUMBER:'License Number',
    LABEL_IDENTIFY_VERIFIED:'Verified',
    LABEL_LICENSE:'License',
    LABEL_IDENTITY_PROOF:'Identity Image',
    
    /* Trade */
    
    /* Users */
    LABEL_COMPANY_NAME: 'Company Name',
    LABEL_CERTIFICATION_NO: 'Certification Number',
    LABEL_CELL_PHONE: 'Cell Phone',
    LABEL_APPROVAL: 'Approval',
    LABEL_PUSH_MESSAGE: 'Push Message',
    LABEL_USER_DETAILS: 'User Details',
    LABEL_USER_CREATED_DATE: 'Created Data',
    LABEL_USER_APPROVAL_DATE: 'Approval Date',
    LABEL_NUMBER_OF_BUYING: 'Number of Buying',
    LABEL_NUMBER_OF_SELLING: 'Number of Selling',
    LABEL_NUMBER_OF_SATISFACTION: 'Number of Satisfaction',
    LABEL_BANK_ACCOUNTS: 'Bank Accounts',
    LABEL_BANK: 'Bank',
    LABEL_ACCOUNT: 'Account',
    LABEL_STATUS:'Status',

    /* Bad Dealers */
    LABEL_REPORTED_DATE_TIME: 'Reported date-time',
    LABEL_REMARK: 'Remark',
    LABEL_USER_NAME: 'User Name',
    LABEL_DEALER_NAME: 'Dealer Name',

    /* Terms */
    LABEL_ADD_TERMS: 'Add Terms',
    LABEL_EDIT_TERMS: 'Edit Terms',
    LABEL_TERMS_OF_SERVICE: 'Terms of Service',
    LABEL_PRIVACY_TERMS: 'Privacy Terms',

    /* Notices */
    LABEL_WRITTEN_DATE: 'Written Date',
    LABEL_PUSH_MESSAGE: 'Push Message',
    LABEL_ADD_NOTICES: 'Add Coupon',
    LABEL_EDIT_NOTICES: 'Edit Coupon',

    /* Advertisments */
    LABEL_ADD_ADVERTISMENTS: 'Add Advertisments',
    LABEL_EDIT_ADVERTISMENTS: 'Edit Advertisments',

    /* Trades */
    LABEL_DEAL_NUMBER: 'Deal Number',
    LABEL_BUYER_NAME: 'Buyer Name',
    LABEL_SELLER_NAME: 'Seller Name',
    LABEL_CAR_PLATE_NUMBER: 'Car Plate Number',
    LABEL_DEAL_START_DATE: 'Deal Start Date',
    LABEL_TIME_TO_SEND_CAR: 'Time to Send a Car',
    LABEL_TIME_TO_RECEIVE_CAR: 'Time to Receive a Car',
    LABEL_DEAL_FINISH_TIME: 'DEAL Finish Time',
    LABEL_TOTAL_PRICE: 'Total Price',
    LABEL_COMMISSION: 'Commission',
    LABEL_CAR_ORIGINAL_PRICE: 'Car Original Price',

    /* Representative number */
    LABEL_REPERSENT_NUMBER: 'Representative Number',

    /* Notifications */
    LABEL_ADD_NOTIFICATIONS: 'Add Notifications',
    LABEL_EDIT_NOTIFICATIONS: 'Edit Notifications',


    //-- buttons
    BTN_ADD: 'Add',
    BTN_SAVE: 'Save',
    BTN_DELETE: 'Delete',
    BTN_CANCEL: 'Cancel',
    BTN_BACK: 'Back',

    //-- Menus
    MENU_LOGOUT: 'Logout',
    MENU_DASHBOARD: 'Dashboard',
    MENU_USER_PROFILE: 'User Profile',
    MENU_MEMBERSHIP_MGT: 'Membership Management',
    MENU_TRADE_MGT: 'Trade Management',
    MENU_BAD_DEALERS_MGT: 'Bad Dealers Management',
    MENU_TERM_POLICY_MGT: 'Term & Policy Management',
    MENU_NOTICE_MGT: 'Notice Management',
    MENU_DISPLAY_ADV_MGT: 'Advertisement Management',
    MENU_NOTIFICATION_MGT: 'Notification Management',
    MENU_REPERSENT_NUMBER_MGT: 'Representative Management',
    MENU_USER_LIST: 'User List',
    MENU_COMMISSION_SETTING:'Commission Setting',
    MENU_DOCUMENT_VERIFICATION:'Document Verification',
    MENU_COUPON:'Coupon',
    MENU_SHOPKEEPER:'Shopkeeper',
    MENU_REPORTS:'Reports',
    MENU_USER_REPORT:'User Report',
    MENU_REVENUE:'Revenue',
    MENU_RIDE:'Ride'
    
};